import { forwardRef } from "react";

import FauxInput, { FauxInputProps } from "../Base/Faux";
import HelperText from "../HelperText";
import Label from "../Label";

export interface FauxFieldProps extends Omit<FauxInputProps, "ref" | "error"> {
  label: string;
  error?: boolean;
  errorMessage?: string;
  helperText?: string;
}

const FauxField = forwardRef<HTMLSpanElement, FauxFieldProps>(
  (
    {
      label,
      error,
      errorMessage = null,
      helperText = null,
      block,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <Label content={label} block={block} className={className}>
        <FauxInput
          block={block}
          error={Boolean(errorMessage || error)}
          ref={ref}
          {...props}
        />
        <HelperText
          content={errorMessage || helperText || ""}
          error={Boolean(errorMessage || error)}
        />
      </Label>
    );
  }
);
FauxField.displayName = "FauxField";

export default FauxField;
